import { Observable } from 'rxjs';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { HttpClient } from '@angular/common/http';
import { LocalRepository } from '@shared/helper/local-repository';
import { Injectable, inject } from '@angular/core';
import { TServiceResult } from '@shared/helper/t-service-result';
import { BookListModel } from '@app/pages/booklists/models/book-list-model';
@Injectable({
    providedIn: 'root'
})

export class BooklistService extends HttpBaseService {
    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'blst');
    }

    createBookList(body: BookListModel): Observable<TServiceResult<string>> {
        return this.http.post<TServiceResult<string>>(`${this.apiUrl}/Create`, body);
    }

    updateBookList(body: BookListModel): Observable<TServiceResult<string>> {
        return this.http.put<TServiceResult<string>>(`${this.apiUrl}/Update`, body);
    }

    deleteBookList(listId: string): Observable<TServiceResult<string>> {
        return this.http.delete<TServiceResult<string>>(`${this.apiUrl}/Delete/${listId}`);
    }
}